let routes = [{
    name: 'Dashboard',
    icon: 'dashboard',
    path: '/',
    permission: true,
    service:true
}
];

export default routes;